import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import { postTargetApiCrud, type PostTargetRequest } from "@/generated/fastapi";

export async function postTarget(
  accessToken: string | null | undefined,
  request: PostTargetRequest,
) {
  const response = await postTargetApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to submit target (${response.status})`);
  }

  return response.data;
}
